import { render, staticRenderFns } from "./AxProjectFileUploadIndicator.vue?vue&type=template&id=3885abba&"
import script from "./AxProjectFileUploadIndicator.vue?vue&type=script&lang=ts&"
export * from "./AxProjectFileUploadIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./AxProjectFileUploadIndicator.vue?vue&type=style&index=0&id=3885abba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports